import React from 'react';
import { Modal } from 'antd';

export default function EllipsisModal({ text, title = 'Texto' }) {
  if (text.length <= 200) {
    return text;
  } else {
    return (
      <div
        onClick={() =>
          Modal.info({
            title: title,
            content: text,
            width: '80%',
            closable: true,
            maskClosable: true,
          })
        }
      >
        {text.substring(0, 200)}... <a>Leer mas</a>
      </div>
    );
  }
}
